/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia'
import { DirectusModule } from '~/types/enums'
import type { Footer, Header, HeaderFooter } from '~/types/types'

export const useHeaderFooterStore = defineStore('header-footer-store', () => {
  const headerFooter = ref<HeaderFooter>({
    header: null,
    footer: null,
  })

  async function getHeaderFooterData() {
    if (headerFooter.value.header !== null && headerFooter.value.footer !== null) return
    try {
      const { $directus, $readItems } = useNuxtApp()

      const [headerData, footerData] = await Promise.all([
        $directus.request($readItems(DirectusModule.Header as any, {})),
        $directus.request($readItems(DirectusModule.Footer as any, {})),
      ])

      if (headerData && footerData) {
        headerFooter.value = {
          header: headerData as unknown as Header,
          footer: footerData as unknown as Footer,
        }
      }
    } catch (error) {
      console.log('Error fetching header and footer data', error)
      // no need to throw error, just log it
    }
  }
  return {
    headerFooter,
    getHeaderFooterData,
  }
})
